import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Spinner, Form, Dropdown } from 'react-bootstrap';
import { getAllAuctions, getAllOpenAuctions, getAllCloseAuctions, getAuctionDetails, convertTokentoNormalAmount } from '../components/blockchain functions/BlockchainFunctions';//API to get Data from wave account
import { convertNormaltoTokenAmount } from '../components/blockchain functions/BlockchainFunctions';

import { placeBid, instantBuy } from "../components/contract functions/AuctionCall";
import GetNFT from '../components/page-components/getNFT';
import { LoginContext } from "../context/LoginContext";
import { validGameNFT } from "../components/page-components/Random";
//icons
import market from '../components/assets/icons/market.svg';
import bidIcon from '../components/assets/icons/auction.svg';
import openIcon from '../components/assets/icons/open-square.svg';
import closeIcon from '../components/assets/icons/close-square.svg';


const Market = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);//Loading bar
  const [dataFilter, setDataFilter] = useState(0);//filter

  const [NFTdata, setNFTdata] = useState([]);
  const [loginData, setLoginData] = useContext(LoginContext);


  const loadAsset = async () => {
    let auctionList;
    if(dataFilter==0){
      auctionList = await getAllOpenAuctions();
    } else if(dataFilter==1){
      auctionList = await getAllCloseAuctions();
    } else{
      auctionList = await getAllAuctions();
    }
    let NFTdataList = [];
    // console.log(auctionList);
    for (let i = 0; i < auctionList.length; i++) {
      let auctionId = auctionList[i];
      NFTdataList.push(await getAuctionDetails(auctionId));
    }

    setNFTdata(NFTdataList);
    console.log(NFTdataList);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    loadAsset();
  }, [dataFilter]);

  const setPlacebidModal = (_bool, _id) => {
    if (_bool) {
      document.getElementById("placebidButton" + _id).style.display = "none";
      document.getElementById("placebidModal" + _id).style.display = "block";
    } else {
      document.getElementById("placebidModal" + _id).style.display = "none";
      document.getElementById("placebidButton" + _id).style.display = "block";
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log(event.target
    var auctionId = event.target.auctionId.value;
    var key = event.target.divIndexKey.value;
    var bidAmount = convertNormaltoTokenAmount(event.target.bidAmount.value);
    // console.log(auctionId, bidAmount, event.target.auctionInstantPrice.value);
    let result;
    if(bidAmount==event.target.auctionInstantPrice.value){
        result = await instantBuy(auctionId, bidAmount, loginData.phrase);
    } else
        result = await placeBid(auctionId, bidAmount, loginData.phrase);
    // let result = await placeBid(, bidAmount, loginData.phrase);
    toast.success("Bid placed successfully");
    setPlacebidModal(false, key);
  }

  return (
    <>
      <div className="page-heading">
        <h2><img style={{ height: "3rem" }} src={market} /> Market</h2>
        <span>Here you can Sell your NFT!</span>
      </div>
      <hr />

      <Dropdown>
        <Dropdown.Toggle id="dropdown-basic" variant="light">
          {dataFilter == 0 ? "Open Auctions" : dataFilter == 1 ? "Closed Auctions" : "All Auctions"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setDataFilter(0)}>Open Auctions</Dropdown.Item>
          <Dropdown.Item onClick={() => setDataFilter(1)}>Close Auctions</Dropdown.Item>
          <Dropdown.Item onClick={() => setDataFilter(2)}>All Auctions</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <div className={loading ? 'parentDisable' : ''} width="100%">
        <br />
        <div className={loading ? 'overlay-box' : 'hide'}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <h4>wait till data is loading from blockchain</h4>
        </div>
        {!loading ? <Container>

          <Row>
            {NFTdata.map((data, key) => {
              return (
                validGameNFT(data.assetData.name) ?
                <Col sm={12}>
                  <div className="auctionStatusImg"><img src={data.status == "open" ? openIcon : closeIcon} /></div>
                  <div className="nftData">
                    <Row>
                      <Col sm={4} onClick={e => history.push('/view-auction/' + data.auctionId)}>
                        <GetNFT nftName={data.assetData.name} />
                      </Col>
                      <Col sm={8}>
                        <Row onClick={e => history.push('/view-auction/' + data.auctionId)} >
                          <Col sm={6} className="details d-grid gap-1">
                            <div className="d-inline p-2 bg-dark text-white" style={{ height: "40px", borderRadius: "100px", textAlign: "center" }}><b>  Asset Details</b></div>
                            <p><span className="fw-bold">Asset Id</span> : {data.assetData.assetId} </p>
                            <p><span className="fw-bold">Name</span> : {data.assetData.name} </p>
                            <p><span className="fw-bold">Description</span> : {data.assetData.description} </p>
                            <p><span className="fw-bold">Created Date</span> : {new Date(data.assetData.issueTimestamp).toLocaleString()}</p>
                          </Col>
                          <Col sm={6} className="details d-grid gap-1">
                            <div className="d-inline p-2 bg-dark text-white" style={{ height: "40px", borderRadius: "100px", textAlign: "center" }}><b>  Auction Details</b></div>
                            <p><span className="fw-bold">AuctionId</span> : {data.auctionId} </p>
                            <p><span className="fw-bold">Initial price</span> : {convertTokentoNormalAmount(data.auctionStartPrice).substr(0,4)} </p>
                            <p><span className="fw-bold">Buyout Price</span> : {convertTokentoNormalAmount(data.auctionInstantPrice).substr(0,4)} </p>
                            <p><span className="fw-bold">OwnerId</span> : {data.auctionOwner} </p>
                            <p><span className="fw-bold">Auction Start Date</span> : {new Date(data.auctionStartedAt).toLocaleString()}</p>
                            <p><span className="fw-bold">Total Bids</span> : {data.totalBids}</p>
                          </Col>
                        </Row>
                        <Row>
                          <hr />
                          {data.status == "open" ?
                            <>
                              <div id={"placebidModal" + key} style={{ display: "none" }}>
                                <Form onSubmit={handleSubmit}>
                                  <Row>
                                    <Col sm={2}>
                                      <Form.Label>Select Bid Amount</Form.Label>
                                    </Col>
                                    <Col sm={6}>
                                      <Form.Group className="mb-3" controlId="forBidAmount">
                                        <Form.Control type="number" min={convertTokentoNormalAmount(data.auctionStartPrice).substr(0,4)} step="0.05" defaultValue={convertTokentoNormalAmount(data.auctionStartPrice).substr(0,4)} max={convertTokentoNormalAmount(data.auctionInstantPrice).substr(0,4)} id="bidAmount" required />
                                      </Form.Group>
                                    </Col>
                                    <Form.Control type="text" id="auctionId" value={data.auctionId} style={{ display: "none" }} />
                                    <Form.Control type="number" id="auctionInstantPrice" value={data.auctionInstantPrice} style={{ display: "none" }} />
                                    <Form.Control type="text" id="divIndexKey" value={key} style={{ display: "none" }} />
                                    <Col sm={2}>
                                      <Button variant="primary" type="submit" style={{ width: "100%" }}>
                                        Submit
                                      </Button>
                                    </Col>
                                    <Col sm={2}>
                                      <Button variant="secondary" style={{ width: "100%" }} onClick={() => setPlacebidModal(false, key)}>
                                        Cancel
                                      </Button>
                                    </Col>
                                  </Row>
                                </Form>
                              </div>
                              <div id={"placebidButton" + key}>
                                <Button variant="outline-primary" style={{ borderRadius: "10px", height: "50px", marginTop: "10px", width: "100%" }}
                                  onClick={() => setPlacebidModal(true, key)} disabled={loginData==null||loginData?.phrase==""}>
                                    <img style={{height:"2rem"}} src={bidIcon}/>Place Bid</Button>
                              </div>
                            </>
                            : 
                            <div style={{ padding: "6px", borderRadius: "100px", textAlign: "center", width: "100%", backgroundColor: "#dc3545", color: "white" }}>
                              Auction is {data.status}.
                            </div>}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
                : <></>
              );
            })}
          </Row>
        </Container>
          : <></>}
      </div>
    </>
  )
}

export default Market